import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import useWindowDimensions from "./windowDimensions";
import ReactCodeInput from "react-code-input";
import { isRtl } from "../services/Helpers";
import { useTranslation } from "react-i18next";
import { Icon } from "@material-ui/core";
import { verifyCode, sendSMSV2 } from "../services/actions";
import Alert from '@material-ui/lab/Alert';
import "../styles/verificationModal.css";
export default function VerificationContent({
  modalState,
  goThanksScreen,
  phoneNumber,
  countryID,
  handleChangeNumber,
  secondsToWait,
  serviceCallId
}) {
  const [isPinCodeValid, setIsPinCodeValid] = useState(true);
  const [pinCode, setPinCode] = useState("");
  const [timeRemainingForResend, setTimeRemainingForResend] = useState();
  const [t] = useTranslation();
  const { height, width } = useWindowDimensions();
  const intSecondsToWait = parseInt(secondsToWait) + 1; //+1 to make sure sending code without errors
  useEffect(() => {
    if (secondsToWait) setTimeRemainingForResend(intSecondsToWait);
  }, []);

  useEffect(() => {
    if (timeRemainingForResend > 0) {
      setTimeout(() => setTimeRemainingForResend((prev) => prev - 1), 1000);
    }
  }, [timeRemainingForResend]);

  const useStyles = makeStyles((theme) => ({
    btn: {
      //backgroundColor: `#00b3de`,
      //   border: `none`,
      //   borderRadius: `.5em`,
      //   padding: `.5em 2em`,
      //   margin: "10%",
      //   color: `#fff`,
      //   fontSize: `1.2em`,
      //   fontWeight: 500,
    },
    contentContainer: {
      minWidth: width * 0.6,
      maxWidth: width * 0.7,
      width: width,
      minHeight: height * 0.45,
      boxShadow: theme.shadows[5],
      backgroundColor: theme.palette.background.paper,
    },
    headers: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: "1%",
    },
    headerH1: {
      display: "flex",
      textAlign: "center",
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: "30px",
      lineHeight: "26px",
    },
    headerH4: {
      display: "flex",
      textAlign: "center",
      margin: "3%",
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "19px",
      lineHeight: "26px",
    },
    footerText: {
      fontFamily: "Roboto",
      fontWeight: 500,
      fontSize: "14px",
      backgroundColor: "#0F171C",
      color: "white",
      lineHeight: "16px",
    },
    footerTextLink: {
      backgroundColor: "#00B3DE",
    },
    label: {
      //  color: "red",
      marginTop: "50px",
      fontAize: "28px",
      fontWeight: 500,
      lineHeight: 1.21,
      letterSpacing: "0.37px",
      marginBottom: "100px",
    },
    sendButton: {
      width: "152px",
      height: "46px",
      backgroundColor: "#00B3DE",
      color: "white",
      borderRadius: "30px",
      fontSize: "18px",
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: 700,
      textTransform: "capitalize",
    },
  }));

  const classes = useStyles();

  const handlePinChange = (pinCode) => {
    setPinCode(pinCode);
  };
  const checkPinCode = async () => {
    const pinCodeValidation = await verifyCode(phoneNumber, pinCode, serviceCallId);
    if (pinCodeValidation.status === 200) {
      setIsPinCodeValid(true);
      modalState(true);
      goThanksScreen(true);
    } else {
      setIsPinCodeValid(false);
      setPinCode("");
    }
  };

  return (
    <div
      id="contentContainerId"
      className={classes.contentContainer + " contentContainer"}
    >
      <div className={classes.headers}>
        <Typography className={classes.headerH1} id="modal-title">
          {t("VerifyNumber")}
        </Typography>
        <Typography className={classes.headerH4} id="modal-title">
          {t("EnterCode")} {phoneNumber}
        </Typography>
      </div>
      <ReactCodeInput
        id="pinCode"
        type="tel"
        isValid={isPinCodeValid}
        fields={4}
        onChange={handlePinChange}
        value={pinCode}
        style={{ textAlign: "center" }}
        inputStyle={{
          textAlign: "center",
          fontFamily: "monospace",
          appearance: "textfield",
          borderRadius: "6px",
          border: "1px solid lightgrey",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px 0px",
          margin: "18px",
          width:
            width <= 374
              ? "12%"
              : width <= 408
              ? "13%"
              : width <= 533
              ? "13%"
              : "44px",
          height: "46px",
          fontSize: "20px",
          boxSizing: "border-box",
          color: "black",
          backgroundColor: "white",
        }}
        inputStyleInvalid={{
          textAlign: "center",
          fontFamily: "monospace",
          appearance: "textfield",
          borderRadius: "6px",
          border: "1px solid lightgrey",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px 0px",
          margin: "18px",
          paddingLeft: "8px",
          width:
            width <= 374
              ? "12%"
              : width <= 408
              ? "13%"
              : width <= 533
              ? "13%"
              : "44px",
          height: "46px",
          fontSize: "20px",
          boxSizing: "border-box",
          color: "rgb(185, 74, 72)",
          backgroundColor: "rgb(242, 222, 222)",
        }}
      />

      {!isPinCodeValid && <Alert severity="error">{t("InvaidCode")}</Alert>}
      <Button
        variant="contained"
        className={classes.sendButton}
        onClick={checkPinCode}
        size={"large"}
        endIcon={
          <Icon style={isRtl() ? { marginRight: "10px" } : {}}>
            {isRtl() ? "west" : "east"}
          </Icon>
        }
      >
        {t("Continue")}
      </Button>
      <div className={classes.headers}>
        <Typography id="modal-title" variant="body2">
          {t("IsCodeReceived")}
        </Typography>
        <Typography id="modal-title" variant="body2">
          <Button
            variant="text"
            size="small"
            disabled={timeRemainingForResend > 0 ? true : false}
            style={{
              color: timeRemainingForResend > 0 ? "gray" : "#00B3DE",
              backgroundColor: "white",
            }}
            onClick={() => {
              sendSMSV2(phoneNumber, countryID);
              setTimeRemainingForResend(intSecondsToWait);
            }}
          >
            {t("Resend")}
          </Button>
          <text>{t("In") + " "}</text>
          <text>{timeRemainingForResend}</text>
          <text>{" " + t("Seconds")}</text>
        </Typography>
        <Typography variant="body2" id="modal-title">
          {t("IsWrongNumber")}
          <Button
            variant="text"
            size="small"
            style={{ color: "#00B3DE", backgroundColor: "white" }}
            onClick={() => handleChangeNumber()}
          >
            {t("Change")}
          </Button>
        </Typography>
      </div>
    </div>
  );
}
